import { useQuery } from '@tanstack/react-query';
import { fetchPlans, type PlanListParams } from '../services/plans';

export const plansQueryKey = (params: PlanListParams) => ['smr-admin', 'plans', params];

export function usePlansQuery(params: PlanListParams = {}) {
    return useQuery({
        queryKey: plansQueryKey(params),
        queryFn: () => fetchPlans(params),
    });
}
